import AboutIcon from "common/icons/about";
import ContactIcon from "common/icons/contact";
import PublicationsIcon from "common/icons/publications";
import RecognisionIcon from "common/icons/recognision";
import StartupIcon from "common/icons/startup";
import TesimonialIcon from "common/icons/testimonials";

import Contact from "pages/Contact/Contact";
import { Home } from "pages/home";
import { PublicationPage } from "pages/publications";
import RecognitionsAndTalks from "pages/recogonitions";
import Startups_Projects from "pages/Startups_Projects/Startups_Projects";
import { Testimonials } from "pages/Testimonial";

export const menuArray = [
  {
    MainMenu: "About Me",
    svg: AboutIcon,
    path: "/home",
    component: Home,
    speed: "about",
    name: "ABOUT ME",
  },
  {
    MainMenu: "Startups & Projects",
    svg: StartupIcon,
    path: "/StartupsProjects",
    component: Startups_Projects,
    speed: "startups",
    name: "START UPS & PROJECTS",
  },

  {
    MainMenu: "Publications & Patents",
    svg: PublicationsIcon,
    path: "/publications",
    component: PublicationPage,
    speed: "publications",
    name: "PUBLICATIONS & PATENTS",
  },
  {
    MainMenu: "Recogonitions & Talks",
    svg: RecognisionIcon,
    path: "/RecognitionsAndTalks",
    component: RecognitionsAndTalks,
    speed: "recognitionSpeed",
    name: "RECOGONITIONS & TALKS",
  },
  {
    MainMenu: "Testimonials",
    svg: TesimonialIcon,
    path: "/testimonials",
    component: Testimonials,
    speed: "testimonials",
    name: "TESTIMONIALS",
  },
  {
    MainMenu: "Contact",
    svg: ContactIcon,
    path: "/contact",
    component: Contact,
    speed: "contact",
    name: "CONTACT",
  },
];
